import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Userpilot } from 'userpilot'
import useMediaQuery from '@/hooks/use-media-query'
import { Heading, ParagraphRegular } from '@/components/text'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Stack, Box } from '@/components/structure'
import { WarningBanner } from '@/components/banner'
import { breakpoints, colors } from '@/styles'
import ENV_VARS from '@/config'

const { WEB_URL } = ENV_VARS

const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  button,
  a {
    flex: 1;
  }
`

type AddendumLimitProps = {
  planType: 'personal' | 'growth'
}

const AddendumLimitReached: React.FC<AddendumLimitProps> = ({ planType }) => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const padding = 24
  const handlePricingClick = () => {
    Userpilot.track('app_upgrade_createcontract_addendum_compare_plan_btn')
    window.open(`${WEB_URL}/pricing`)
  }
  return (
    <>
      <WarningBanner />
      <Box ptop={padding} pbottom={padding} pleft={padding} pright={padding}>
        <Stack gutter="32px">
          <Stack gutter="8px" textAlign="center">
            <Heading type={!displayMobile ? 'h4' : 'h5'}>
              {t('l.contract.edit.addendum_limit_reached.heading', 'Plan Upgrade Required')}
            </Heading>
            <Stack color={colors.grey56} gutter="24px">
              <ParagraphRegular>
                {planType === 'personal'
                  ? t(
                      'l.contract.edit.addendum_limit_reached.personal_text',
                      'Your Essentials plan does not have access to Addendums. Please review our plan comparison page and select a plan matching your needs to gain access.'
                    )
                  : t(
                      'l.contract.edit.addendum_limit_reached.family_text',
                      'Your Growth plan does not have access to Company Addendums. Please review our plan comparison page and select a plan matching your needs to access.'
                    )}
              </ParagraphRegular>
            </Stack>
          </Stack>
          <ButtonWrapper>
            <Button theme="secondary" onClick={close}>
              {t('common.cancel', 'Cancel')}
            </Button>
            <Button onClick={handlePricingClick}>
              {t('l.contract.edit.addendum_limit_reached.button', 'Compare Plans')}
            </Button>
          </ButtonWrapper>
        </Stack>
      </Box>
    </>
  )
}

const showAddendumLimitModal = createModal(AddendumLimitReached, {
  width: '492px',
  showClose: false
})

export default showAddendumLimitModal
